window.DependentCount = (function () {
    window.dataLayer = window.dataLayer || [];
    let self = {
        elements: {
            buttons: {
                cancelButton: '#dependent-count-form-cancel',
                continueButton: '#dependent-count-form-continue',
                minusButton: '#dependent-count-form-minus',
                plusButton: '#dependent-count-form-plus'
            },
            textBox:{
                textBox1: '#dependent-count-form-stepper'
            },
            messages:{
                invalidFormMessage: '#dependent-count-form-invalid-form-message',
                maxCountWarningMessage: '#dependent-count-form-max-count-warning-message'
            }
        },
        urls: {
            manageMembers: '/my-health-insurance/manage-my-plan/manage-members',
            resetSession: '/api/sitecore/AddMembers/ResetSession',
            errorPageUrl: '/error/error-page',
            aboutChild: '/my-health-insurance/manage-my-plan/add-members/about-child',
            cacheDependentCountDetails: '/api/sitecore/AddMembers/CacheDependentCountDetails'
        },
        statusDescription: {
            ok: 'ok'
        },
        constants: {
            maxChildrenCount: '5'
        },
        func: {
            init: function () {
                self.func.bindings();
                self.func.initializeValidationMessage();
            },
            bindings: function () {
                $(self.elements.buttons.continueButton).on('click', self.func.handleDependentCountRequest);
                $(self.elements.buttons.cancelButton).on('click', self.func.cancelRequest);
                $(self.elements.textBox.textBox1).on('input', self.func.validateMessages);
                $(self.elements.buttons.minusButton).on('click', self.func.validateMessages);
                $(self.elements.buttons.plusButton).on('click', self.func.validateMessages);
            },
            initializeValidationMessage: function () {
                $(self.elements.messages.invalidFormMessage).hide();
                $(self.elements.messages.maxCountWarningMessage).hide();
            },
            handleDependentCountRequest: function (event) {
                event.preventDefault();
                self.func.validateMessages();
                let allowedNumbers = ['1','2','3','4','5'];
                if(!allowedNumbers.includes($(self.elements.textBox.textBox1).val())) {
                        $(self.elements.messages.invalidFormMessage).show();
                        return;
                }

                $.ajax({
                    type: 'POST',
                    url: self.urls.cacheDependentCountDetails,
                    data: {dependentCount: $(self.elements.textBox.textBox1).val()},
                    success: self.func.success,
                    error: self.func.error
                });

            },
            success: function () {
                window.location.href = self.urls.aboutChild;
            },
            error: function () {
                window.location.href = self.urls.errorPageUrl;
            },
            cancelRequest: function (event) {
                event.preventDefault();
                // AJAX call to reset the session.
                $.post(self.urls.resetSession)
                    .done(function () {
                        window.location.href = self.urls.manageMembers;
                    })
                    .fail(function () {
                        window.location.href = self.urls.errorPageUrl;
                    });
            },
            validateMessages: function () {
                $(self.elements.messages.invalidFormMessage).hide();
                if($(self.elements.textBox.textBox1).val() === self.constants.maxChildrenCount) {
                    $(self.elements.messages.maxCountWarningMessage).show();
                }
                else {
                    $(self.elements.messages.maxCountWarningMessage).hide();
                }
            }
        }
    };

    return {
        Init: self.func.init
    };
})();

$(document).ready(function () {
    if ('dependentCount' === $('#dependent-count-form').data('feature')) {
        window.DependentCount.Init();
    }
});
